import { LTLQuote } from '../types';

const DEFAULT_SELECTED_LTL_QUOTES_COUNT = 3;

// Cheapest successful quotes, one per carrier and price, preferring contract pricing.
export function getDefaultSelectedLTLQuotes(
  quotes: LTLQuote[],
  maxSelected: number = DEFAULT_SELECTED_LTL_QUOTES_COUNT
): LTLQuote[] {
  const successfulQuotes = quotes
    .filter((q) => !q.isError && !q.notServiced)
    .sort((a, b) => a.totalCost - b.totalCost);

  const selectedByDedupKey = new Map<string, LTLQuote>();
  const keyOrder: string[] = [];

  for (const quote of successfulQuotes) {
    const dedupKey = getLTLDedupSelectionKey(quote);
    const existing = selectedByDedupKey.get(dedupKey);
    if (!existing) {
      selectedByDedupKey.set(dedupKey, quote);
      keyOrder.push(dedupKey);
      continue;
    }

    if (
      getLTLPricingTypePriority(quote) < getLTLPricingTypePriority(existing)
    ) {
      selectedByDedupKey.set(dedupKey, quote);
    }
  }

  return keyOrder
    .map((key) => selectedByDedupKey.get(key))
    .filter((quote): quote is LTLQuote => Boolean(quote))
    .slice(0, maxSelected);
}

function getLTLPricingTypePriority(quote: LTLQuote): number {
  const pricingType = quote.rateMetadata?.pricingType?.trim().toLowerCase();
  switch (pricingType) {
    case 'contract':
      return 0;
    case 'volume':
      return 1;
    case 'dynamic':
      return 2;
    default:
      return 3;
  }
}

function getLTLDedupSelectionKey(quote: LTLQuote): string {
  const carrierKey = (quote.carrierSCAC || quote.carrierName || '')
    .trim()
    .toLowerCase();
  return `${carrierKey}|${quote.totalCost.toFixed(2)}`;
}
